var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1Bus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 27H4v25.88L12.32 55a7 7 0 1114 0H52a7 7 0 1114 0h5V40c0-3.71-1.87-10.23-8-13zM11 40H8v-9h3v9zm14 0H14v-9h11v9zm15 0H29v-9h11v9zm15 0H44v-9h11v9zm4 0v-9h3c3.91 2.19 5 6.77 5 9h-8zm4 15a4 4 0 11-8 0 4 4 0 018 0zm-40.85-2.83a4 4 0 11-5.654 5.66 4 4 0 015.654-5.66z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Bus.f2d980f0.svg";
export { SvgI1Bus as ReactComponent };